/**
 * 仕入先内示出力(ExportFileType)用のサービス
 */
export class ExportSupplierForecastExcelService {
  /**
   * 仕入先内示出力(ExportFileType)用に、内示・販売実績数量が入っている列を表すkey(年_列名(月情報あり)の形)を返す
   * 仕入先内示出力（ダウンロード）の際に使用
   * @param headerString - 列のヘッダー名
   * @param yearMonthString - 年_月の文字列
   */
  public static updateAmountColumnsRowKey = (headerString: string, yearMonthString: string): string => {
    if (!yearMonthString) return yearMonthString; // 空セルを読む場合があるので回避

    // 列名に「月内示」、「月販売実績」が含まれている文字列を更新する
    if (headerString.includes('月内示') || headerString.includes('月販売実績')) {
      const yearStr = yearMonthString.split('_')[0];
      // 年_列名(月情報ある)形にして返す
      return yearStr + '_' + headerString;
    }
    // 更新対象以外は入力値をそのまま返す
    return yearMonthString;
  };
}
